<div class="global-loading-overlay" *ngIf="loading || (globalLoading$ | async) === true" aria-label="Loading">
  <div class="global-loading-spinner"></div>
</div>

<div *ngIf="!loading">
  <div class="top-nav">
    <div class="title">
      <img src="../assets/gmLogo.svg" alt="GM"/>
      Partner Remote Access Inventory Viewer
    </div>
    <nav class="nav-buttons">
      <div class="nav-button" routerLink="/view" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <img src="../assets/icon-book.svg" class="icon"/>
        Inventory
      </div>
      <div class="nav-button" routerLink="/sync" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <img src="../assets/icon-sync.svg" class="icon"/>
        Sync Status
      </div>
      <div class="nav-button" routerLink="/change" routerLinkActive="active">
        <img src="../assets/icon-clock.svg" class="icon"/>
        Change Control
      </div>
      <div class="nav-button" routerLink="/access" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">manage_accounts</mat-icon>
        Access Control
      </div>

      <a class="nav-button" href="https://link.gm.com/ASADeployToolkit" target="_blank" rel="noopener noreferrer">
        <img src="../assets/icon-tools.svg" class="icon"/>
        Deployment Toolkit
      </a>
    </nav>
  </div>
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
</div>